module.exports = __webpack_public_path__ + "static/img/icon_game_4.fc254f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_4.png
// module id = g0cU
// module chunks = 0